// @flow
import type {Element} from 'react'
import React from 'react'
import {graphql, useFragment} from 'react-relay'

import type {
  TacticalMeetingProjectsView_role$key as RoleKey,
} from './__generated__/TacticalMeetingProjectsView_role.graphql'

type Props = $ReadOnly<{
  roleKey: RoleKey,
}>

const roleFragment = graphql`
  fragment TacticalMeetingProjectsView_role on Role  
  {
    databaseId

    organization {
      databaseId
    }
  }
`

export default function TacticalMeetingProjectsView({roleKey}: Props): Element<"div"> {
  const role = useFragment(roleFragment, roleKey)
  const roleDatabaseId = role.databaseId
  const orgDatabaseId = role.organization.databaseId
  const queryParams = window.location.search
  const separator = (queryParams.indexOf('?') > 0) ? '&' : '?'

  // If you are searching for GfTab::MEETING_PROJECTS, it is here.

  return (
    <div id="tactical-meeting-projects-tab">
      <turbo-frame
        id="content-frame"
        src={`/organizations/${orgDatabaseId}/roles/${roleDatabaseId}/projects${queryParams}${separator}tab=meeting_projects&project_group=person&project_view=kanban`}
      />
    </div>
  )
}

export const UnwrappedTacticalMeetingProjectsView = TacticalMeetingProjectsView
